import _ from 'lodash'

class MonthlyProductionService {
  constructor(MonthlyProduction) {
    this.MonthlyProduction = MonthlyProduction
    this.monthlyProduction = null
  }

  queryMonthlyProduction(recordId) {
    this.monthlyProduction = this.MonthlyProduction.get({id: recordId})
    return this.monthlyProduction
  }
}

MonthlyProductionService.$inject = ['MonthlyProduction']

export default MonthlyProductionService